import React from 'react';
import { Player } from '../classes/Player';

interface PodiumInterface {
    players: Player[];
    playersMap: Map<number, number[]>;
    score: number;
    place: number;
};

function Podium({players, playersMap, score, place}: PodiumInterface) {
    const getHeight = () => {
        if (place === 1) {
            return "100%";
        } else if (place === 2) {
            return "60%";
        } else if (place === 3) {
            return "40%";
        }
        return "";
    }

    const getPlaceText = () => {
        if (place === 1) {
            return "1st";
        } else if (place === 2) {
            return "2nd";
        } else if (place === 3) {
            return "3rd";
        }
        return "";
    }

    const getNames = () => {
        let playersStr = "";
        const placePlayers = playersMap.get(score) ?? [];
        for (let idx = 0; idx < placePlayers.length; idx++) {
            const playerIdx = players.findIndex((p) => p.id === placePlayers[idx]);
            if (playerIdx !== -1) {
                playersStr += String(players[playerIdx].name) + ", ";
            }
        }
        if (playersStr.length > 0) {
            return playersStr.substring(0, playersStr.length - 2); // remove the last comma and space
        }
        return "";
    }

    return (
        <div className="podiumWrapper" style={{height: getHeight()}}>
            {score !== -1 && playersMap.get(score) !== undefined && <div className="podiumPointsAndNameWrapper">
                <div className="podiumPoints">
                    {score === 1 ? String(score) + "pt" : String(score) + "pts"}
                </div>
                <div className="podiumNames">{getNames()}</div>
            </div>}
            <div className="podiumPlace">{getPlaceText()}</div>
        </div>
    );
};

export default Podium;